export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 sm:gap-4">
      <div>
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight" style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}>
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function Th({ children, right }) {
  return <th className={`${right ? "text-right" : "text-left"} px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400`}>{children}</th>;
}

export function CheckList({ items, value, onChange, testPrefix }) {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="grid grid-cols-2 gap-1.5">
      {items.map((it) => (
        <label key={it.id} className="flex items-center gap-2 text-sm cursor-pointer px-2 py-1.5 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800">
          <input type="checkbox" className="accent-emerald-600" checked={value.includes(it.id)} onChange={() => toggle(it.id)} data-testid={`${testPrefix}-${it.id}`} />
          <span className="text-slate-700 dark:text-slate-300">{it.label}</span>
        </label>
      ))}
      {items.length === 0 && <p className="text-xs text-slate-400 col-span-2">Nenhum item disponível.</p>}
    </div>
  );
}
